module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/p-money-399.74c14f370fa73e34.png"+" 399w",
        images: [{path: "https://static.sniffspot.com/packs/img/p-money-399.74c14f370fa73e34.png",width: 399,height: 138}],
        src: "https://static.sniffspot.com/packs/img/p-money-399.74c14f370fa73e34.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/p-money-399.74c14f370fa73e34.png"},
        
        width: 399,
        height: 138
      }